import { render, staticRenderFns } from "./AnterioSegmentOct.vue?vue&type=template&id=17dbe7d8&"
import script from "./AnterioSegmentOct.vue?vue&type=script&lang=js&"
export * from "./AnterioSegmentOct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports